import { features, isFeatureEnabled } from '#lib/stores/feature-flip.js';
import { apiAppPaymentStripeconnectGetstatus } from '#lib/types/generated/api.gen.js';
import { get, writable } from 'svelte/store';

export const stripeActionRequiredStore = writable<boolean>(false);

let isChecking = false;

export async function checkStripeActionRequired(): Promise<boolean> {
	if (
		!get(isFeatureEnabled)(features.PaymentDisplay) &&
		!get(isFeatureEnabled)(features.Payment)
	) {
		stripeActionRequiredStore.set(false);
		return false;
	}

	if (isChecking) {
		return get(stripeActionRequiredStore);
	}

	isChecking = true;

	try {
		const res = await apiAppPaymentStripeconnectGetstatus();
		stripeActionRequiredStore.set(res.hasActionRequired);
		return res.hasActionRequired;
	} catch {
		return false;
	} finally {
		isChecking = false;
	}
}

export function setStripeActionRequired(actionRequired: boolean): void {
	stripeActionRequiredStore.set(actionRequired);
}
